export default function Plural({count, plural, singular, hideZero, render}) {
    if(count === 0)
        return ``

    return (
        <>
            {
                !hideZero && count !== 0 && render(count, Math.abs(count) <= 1 ? singular : plural)
            }
        </>
    )
}